module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_chapel-d229257b42581d7875ad53dcf88c0b6d.jpg";